// fetch url
const FETCH_URL = 'http://52.62.150.109:8080';
const RELEASE_URL = 'https://zangsu-backend.store';

// fetch method
const FETCH_METHOD = {
  GET: 'GET',
  POST: 'POST',
};

// modal variable
const MODAL_TOP = {
  SHOW: '0vh',
  HIDE: '-100vh',
};

// service logic
const USER_NONE_INPUT = '0';
const LAST_PROBLEM = 5;

export {
  FETCH_URL,
  RELEASE_URL,
  FETCH_METHOD,
  MODAL_TOP,
  LAST_PROBLEM,
  USER_NONE_INPUT,
};
